module.exports = __webpack_public_path__ + "static/media/wonde-logo.38cb5341.png";